import { Link } from 'react-router';
import { dsClass } from '../../../common/constants/dsClasses';
import { paths } from '../../../common/constants/pathVariables';
import {
  consumerOmaElisaLowercaseMsg,
  instructionsForServiceMsg,
  instructionsMsg,
  seeMsg,
  subscriptionStatusMsg,
  subscriptionStatusWarningMsg,
  t,
} from '../../../common/i18n';
import { CONSUMER_OMAELISA_LOGIN_URL, isSubscriptionInSaunalahti } from '../../../common/utils/subscriptionUtils';
import { SubscriptionType } from '../../../generated/api/subscriptionType';
import type { Subscription } from '../../../generated/api/subscription';

const getAdditionalInstructionsLink = (subscription: Subscription) => {
  switch (subscription.subscriptionType) {
    case SubscriptionType.MOBILE:
    case SubscriptionType.LANDLINE:
    case SubscriptionType.SPECIAL_NUMBER:
    case SubscriptionType.MOBILE_PBX_END_USER_SERVICE:
      return paths.INSTRUCTIONS_VOICE_SUBSCRIPTIONS;
    case SubscriptionType.MOBILE_BROADBAND:
    case SubscriptionType.MOBILE_M2M:
      return paths.INSTRUCTIONS_MOBILE_BROADBAND;
    case SubscriptionType.BROADBAND:
    case SubscriptionType.CORPORATE_NETWORK:
    case SubscriptionType.HOUSING_COMPANY_BROADBAND:
      return paths.INSTRUCTIONS_FIXED_BROADBAND;
    case SubscriptionType.DEVICE:
      return subscription.details?.device?.eppSubscription ? paths.INSTRUCTIONS_EPP_ADMIN : paths.INSTRUCTIONS;
    default:
      return undefined;
  }
};

export const SaunalahtiCardContent = () => {
  return (
    <>
      <h3>{t.RD4R(instructionsMsg)}</h3>
      <p>
        {t.ONU5(
          `This is Corporate customer of Elisa's consumer subscription (former Saunalahti company customer). You can manage the subscription in `
        )}
        <Link to={CONSUMER_OMAELISA_LOGIN_URL} target="_blank" rel="noopener noreferrer">
          {t.AS63(consumerOmaElisaLowercaseMsg)}
        </Link>
        .
      </p>
    </>
  );
};

export const CardContent = ({ subscription }: { subscription: Subscription }) => {
  if (isSubscriptionInSaunalahti(subscription)) {
    return <SaunalahtiCardContent />;
  }
  const instructionsLink = getAdditionalInstructionsLink(subscription);
  if (!instructionsLink) {
    return null;
  }
  return (
    <>
      <h3>{t.RD4R(instructionsMsg)}</h3>
      <p>
        {t.V09Q(
          'You can schedule a change in the user interface if it concerns a user change or a billing agreement change.'
        )}
      </p>
      <ul className={dsClass.LIST_UNORDERED}>
        <li>{t.LN3T('Changing the contracting company cannot be scheduled.')}</li>
        <li>{t.FKUE('Change can be scheduled up to one month in advance.')}</li>
      </ul>
      <p>
        {t.LJ10(seeMsg)}
        <Link to={instructionsLink} target="_blank" rel="noopener noreferrer">
          {t.Z72R(instructionsMsg.toLowerCase())}
        </Link>
        {t.U63I(instructionsForServiceMsg)}
      </p>
      {subscription.subscriptionType !== SubscriptionType.DEVICE && (
        <>
          <h4 className={dsClass.MARGIN_BOTTOM_0}>{t.LROP(subscriptionStatusMsg)}</h4>
          <p className={dsClass.MARGIN_TOP_0}>{t.H3T3(subscriptionStatusWarningMsg)}</p>
        </>
      )}
    </>
  );
};
